import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

/**
 * Posé par-dessus la page plutôt qu'à sa place : la page reste montée, un formulaire en cours
 * de saisie survit à la rotation.
 */
export const RotatePhoneOverlay = () => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-[60] flex flex-col items-center justify-center gap-4 bg-tertiary px-8 text-center text-secondary-text">
      <FontAwesomeIcon icon="mobile-screen-button" className="text-5xl" />
      <p className="font-oxaniumMedium text-lg">{t("rotate-phone-title")}</p>
      <p className="text-sm">{t("rotate-phone-text")}</p>
    </div>
  );
};
